<script setup lang="ts">
import { SidebarLayout } from 'catalyst-vue'
import { useLibraryLayout } from '../../lib/library-layout'
import CategorySidebar from './category-sidebar.vue'
import LibraryNavigation from './library-navigation.vue'

/** 書庫與分類管理共用的外框：側邊欄導覽（桌機）或底部導覽（compact）。 */
// 由使用這個外框的 view 呼叫 provideLibraryLayout，外框只消費。
const compact = useLibraryLayout()
defineSlots<{ default(): unknown; 'bottom-bar'(): unknown; 'nav-actions'(): unknown; overlays(): unknown }>()
</script>

<template>
  <a href="#library-content" class="skip-link">跳至內容</a>
  <SidebarLayout variant="flush" sidebar-width="232px" max-width="none" content-padding="none" class="bookshop-layout" :class="{ 'is-compact': compact }">
    <template #sidebar><CategorySidebar v-if="!compact" /></template>
    <div id="library-content" tabindex="-1" class="library-content"><slot /></div>
    <!--
      底部固定的東西全部放進同一個堆疊，由它負責固定；裡面的列各自是一般的區塊元素，
      因此上下疊放不需要任何偏移計算，也不會因為某一條變高就互相重疊。
    -->
    <div class="library-bottom-stack">
      <slot name="bottom-bar" />
      <LibraryNavigation v-if="compact">
        <template #actions><slot name="nav-actions" /></template>
      </LibraryNavigation>
    </div>
    <slot name="overlays" />
  </SidebarLayout>
</template>
